import { cn } from "@omni/utils/styles";

import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";

import { CalculatorImage } from "../../Components/CalculatorImage/calculatorImage.component";

type Props = {
    setCalculationValue: (field: string, value: string) => void;
    setBrickMeasurements: (
        length: number,
        width: number,
        height: number
    ) => void;
    wallLength: number;
    wallHeight: number;
    brickLength: number;
    brickWidth: number;
    brickHeight: number;
};

const Calculation = ({
    setCalculationValue,
    setBrickMeasurements,
    wallLength,
    wallHeight,
    brickLength,
    brickWidth,
    brickHeight
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col className={"col-xs-12 col-md-8"}>
                    <h3 className="d-sm-block">
                        {t("calculator.ytongCalculator.measurementWall")}
                    </h3>
                    <Row>
                        <CalculationField
                            name={"wallLength"}
                            dimension={"length"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            {...(wallLength && { value: wallLength })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                        <CalculationField
                            name={"wallHeight"}
                            dimension={"height"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            {...(wallHeight && { value: wallHeight })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                    </Row>
                    <h3 className="d-sm-block">
                        {t("calculator.ytongCalculator.measurementYtongBlock")}
                    </h3>
                    <Dropdown
                        placement={"bottom"}
                        isLabel={true}
                    >
                        <Dropdown.Toggle>
                            <Dropdown.Label>
                                {t(
                                    "calculator.ytongCalculator.defaultMeasurements"
                                )}
                            </Dropdown.Label>
                            <Dropdown.Caret />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(60, 5, 20)}
                                label="60 x 5 x 20"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(60, 7, 20)}
                                label="60 x 7 x 20"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(60, 10, 20)}
                                label="60 x 10 x 20"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(60, 15, 20)}
                                label="60 x 15 x 20"
                            />
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col className={"col-md-4 d-flex text-center align-items-end"}>
                    <CalculatorImage
                        className={cn("tw:mt-3")}
                        src={DamImage.calculator.yTong}
                        alt={"y-tong.jpg"}
                    />
                </Col>
            </Row>
            <Row className={"mt-4"}>
                <CalculationField
                    name={"brickLength"}
                    dimension={"length"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(brickLength && {
                        value: brickLength.toString().replace(".", ",")
                    })}
                    sm={4}
                    md={3}
                    lg={2}
                />
                <CalculationField
                    name={"brickWidth"}
                    dimension={"width"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(brickWidth && {
                        value: brickWidth.toString().replace(".", ",")
                    })}
                    sm={4}
                    md={3}
                    lg={2}
                />
                <CalculationField
                    name={"brickHeight"}
                    dimension={"height"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(brickHeight && {
                        value: brickHeight.toString().replace(".", ",")
                    })}
                    sm={4}
                    md={3}
                    lg={2}
                />
            </Row>
        </div>
    );
};

export default Calculation;
